/**
 * When a Bootstrap modal or offcanvas is shown, find the first
 * form input with the "autofocus" attribute and focus it.
 *
 */
['shown.bs.modal', 'shown.bs.offcanvas'].forEach(function (eventName) {
  document.addEventListener(eventName, function (event) {
    var targetElement = event.target;
    var autofocusElement = targetElement.querySelector('[autofocus]');
    if (autofocusElement) {
      autofocusElement.focus();
    }
  });
});
